import { Component, input, OnInit, output } from '@angular/core';
import { SetpointTemplateCategory } from 'app/classes/setpoint-template-category';
import { APIService } from 'app/shared/api.service';
import { SetpointsService } from 'app/shared/setpoints.service';

@Component({
  selector: 'app-dialog-setpoint-template-category',
  templateUrl: './dialog-setpoint-template-category.component.html',
  styleUrls: ['./dialog-setpoint-template-category.component.css'],
  standalone: false
})
export class DialogSetpointTemplateCategoryComponent implements OnInit {

  setpointTemplateCategory: SetpointTemplateCategory;

  category = input.required<SetpointTemplateCategory>();

  onClose = output<SetpointTemplateCategory>();

  constructor(public setpointsService: SetpointsService, private apiService: APIService) {

  }

  ngOnInit(): void {
    // Initialize setpointTemplateCategory with the input category or a new instance
    if (this.category()) {
      // Create a copy to avoid mutating the input directly
      this.setpointTemplateCategory = this.category();
    } else {
      this.setpointTemplateCategory = new SetpointTemplateCategory();
    }
  }

  cancel() {
    this.onClose.emit(null);
  }

  async submit() {
    const response = await this.setpointsService.updateTemplateCategory(this.setpointTemplateCategory);
    console.log(response);
    this.apiService.toastSuccess('updated');
    this.onClose.emit(this.setpointTemplateCategory);
  }

}
